'use client';
import React from 'react';

import Class from '@icons/Class.svg';
import Date from '@icons/Date.svg';
import Time from '@icons/Time.svg';

import { InfoContainer } from '@components/Common';
import { RadioButton } from '@components/RadioButton';
import { ShiftInfoCardListingProps } from '@components/ShiftInfoCards/interfaces';
import { InfoItem, ShiftInfoContainer, TimeInfoItem } from '@components/ShiftInfoCards/styles';
import { Text } from '@components/TermsCheckbox';

import { formatDisplayDate, formatDisplayTime } from '@utils/helpers';

/**
 * Shift info card on listing page with radio button
 */
export const ShiftInfoCardListing = ({
  shiftId,
  group,
  date,
  timeFrom,
  timeUntil,
  isSelected,
  onSelect,
}: ShiftInfoCardListingProps) => {
  // Handle radio button selection/deselection
  const handleChange = () => {
    if (isSelected) {
      onSelect(null); // Deselect if already selected
    } else {
      onSelect(shiftId); // Select this shift
    }
  };

  // We need both radio button behavior but also deselect options
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isSelected) {
      onSelect(null); // Deselect if already selected
    } else {
      onSelect(shiftId); // Select this shift
    }
  };

  return (
    <ShiftInfoContainer
      as="label"
      htmlFor={shiftId}
      onClick={handleClick}
      type="button"
      aria-label={'shift info card'}>
      <InfoContainer>
        <InfoItem>
          <Class />
          <Text>{`Groep ${group}`}</Text>
        </InfoItem>
        <TimeInfoItem>
          <InfoItem>
            <Date />
            <Text>{formatDisplayDate(date)}</Text>
          </InfoItem>
          <InfoItem>
            <Time />
            <Text>{`${formatDisplayTime(timeFrom)} - ${formatDisplayTime(timeUntil)}`}</Text>
          </InfoItem>
        </TimeInfoItem>
      </InfoContainer>
      <RadioButton
        id={shiftId}
        name="shift-selection"
        value={shiftId}
        checked={!!isSelected}
        onChange={handleChange}
      />
    </ShiftInfoContainer>
  );
};
